export const YANDEX_API_TELEMETRY_KEY = 'yandexApi.requestsCount';

export const MAX_DISPLAY_TRANSPORT_ACCESSIBILITY_ONBOARDING_COUNT = 3;
export const TRANSPORT_ACCESSIBILITY_ONBOARDING_COOKIE_KEY = 'transport-accessibility_onboarding_counter';

export const MAX_DISPLAY_MAP_PREVIEW_ONBOARDING_COUNT = 3;
export const MAP_PREVIEW_ONBOARDING_COOKIE_KEY = 'map_preview_onboarding_counter';
